import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Callback from "../views/Callback.vue";
import auth from "../Services/auth";

Vue.use(VueRouter);

function requireAuth(to, from, next) {
  if (auth.isAuthenticated()) {
    next();
  } else {
    next({
      //path: '/',
      query: { redirect: to.fullpath },
    });
  }
}

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    beforeEnter: requireAuth,
    component: () => import("../views/Dashboard.vue"),
  },
  {
    path: "/SavingCalculator",
    name: "SavingCalculator",
    beforeEnter: requireAuth,
    component: () => import("../views/SavingCalculator.vue"),
  },
  {
    path: "/VirtualLog",
    name: "VirtualLogbook",
    beforeEnter: requireAuth,
    component: () => import("../views/VirtualLog.vue"),
  },
  {
    path: "/servicingreport",
    Name: "ServicingReport",
    beforeEnter: requireAuth,
    component: () => import("../views/ServicingReport.vue"),
  },
  {
    path: "/alertanderrorreport",
    Name: "AlertAndErrorReport",
    beforeEnter: requireAuth,
    component: () => import("../views/AlertAndErrorReport.vue"),
  },
  {
    path: "/testaxios",
    Name: "TestAxios",
    component: () => import("../views/TestAxios.vue"),
  },
  {
    path: "/servicerequest",
    Name: "ServiceRequest",
    component: () => import("../views/ServiceRequest.vue"),
  },
  {
    path: "/callback",
    Name: "Callback",
    component: Callback,
  },
  {
    path: "/DeviceReport",
    Name: "DeviceReport",
    props: true,
    component: () => import("../components/DeviceReport.vue"),
  },
  {
    path: "/T&C",
    Name: "Terms And Conditions",
    props: true,
    component: () => import("../views/TermsAndConditions.vue"),
  },
  {
    path: "/DeviceList",
    Name: "DeviceList",
    props: true,
    component: () => import("../views/DeviceList.vue"),
  },
  {
    path: "/HistoricDeviceReport",
    Name: "HistoricDeviceReport",
    props: true,
    component: () => import("../components/HistoricDeviceReport.vue"),
  },
  {
    path: "/ClientUserAdmin",
    Name: "ClientUserAdminSuper",
    props: true,
    component: () => import("../components/ClientUserAdminSUP.vue"),
  },
  {
    path: "/InstallerUserAdmin",
    Name: "InstallerUserAdminSuper",
    props: true,
    component: () => import("../components/InstallerUserAdminSUP.vue"),
  },
  {
    path: "/BoardMemberUserAdmin",
    Name: "BoardMemberUserAdminSuper",
    props: true,
    component: () => import("../components/BoardMemberUserAdminSUP.vue"),
  },
  {
    path: "/WaterManagementUserAdmin",
    Name: "WaterManagementUserAdminSuper",
    props: true,
    component: () =>
      import("../components/WaterManagementCompanyUserAdminSUP.vue"),
  },
  {
    path: "/OrderAdmin",
    Name: "OrderAdminSuper",
    props: true,
    component: () => import("../components/OrderAdminSUP.vue"),
  },
  {
    path: "/LocationAdmin",
    Name: "LocationAdminSuper",
    props: true,
    component: () => import("../components/LocationAdminSUP.vue"),
  },
  {
    path: "/CompanyAdmin",
    Name: "CompanyAdminSuper",
    props: true,
    component: () => import("../components/CompanyAdminSUP.vue"),
  },
  {
    path: "/CompanyReport",
    Name: "CompanyReport",
    props: true,
    component: () => import("../components/SUPCompanyDetailReport.vue"),
  },
  {
    path: "/Errors",
    Name: "Errors",
    props: true,
    component: () => import("../components/SUPErrors.vue"),
  },
  {
    path: "/Suspended",
    Name: "Suspended",
    props: true,
    component: () => import("../views/UserSuspension.vue"),
  },
  {
    path: "/FileUpload",
    Name: "FileUpload",
    props: true,
    component: () => import("../views/FileUpload.vue"),
  },
  {
    path: "/Overview",
    Name: "Overview",
    props: true,
    component: () => import("../views/Overview.vue"),
  },
  {
    path: "/TestingResults",
    Name: "TestingResults",
    props: true,
    component: () => import("../views/TestingResults.vue"),
  },
  {
    path: "/RiskAssessments",
    Name: "RiskAssessments",
    props: true,
    component: () => import("../views/RiskAssessments.vue"),
  },
  {
    path: "/FilterManagement",
    Name: "FilterManagement",
    props: true,
    component: () => import("../views/FilterManagement.vue"),
  },
  {
    path: "/reminderalerts",
    Name: "ReminderAlerts",
    props: true,
    component: () => import("../views/ReminderAlerts.vue"),
  },
  {
    path: "/DevicesAndOutlets",
    Name: "DevicesAndOutlets",
    props: true,
    component: () => import("../views/Devices.vue"),
  },
  {
    path: "/LocationGroups",
    Name: "LocationGroups",
    props: true,
    component: () => import("../views/LocationGroups.vue"),
  },
  {
    path: "/Subgroups",
    Name: "Subgroups",
    props: true,
    component: () => import("../views/Subgroups.vue"),
  },
  {
    path: "/Endpoints",
    Name: "Endpoints",
    props: true,
    component: () => import("../components/Endpoints.vue"),
  },
  {
    path: "/SysManagement",
    Name: "SysManagement",
    props: true,
    component: () => import("../views/SysManagement.vue"),
  },
  {
    path: "/AddNew",
    Name: "AddNew",
    props: true,
    component: () => import("../views/AddNew.vue"),
  },
  {
    path: "/SupportOverview",
    Name: "SupportOverview",
    props: true,
    component: () => import("../views/SupportOverview.vue"),
  },
  {
    path: "/RiskControlMeasures",
    Name: "RiskControlMeasures",
    props: true,
    component: () => import("../views/RiskControlMeasures.vue"),
  },
  {
    path: "/StockManagement",
    Name: "StockManagement",
    props: true,
    component: () => import("../views/StockManagement.vue"),
  },
  {
    path: "/ReportsOverview",
    Name: "ReportsOverview",
    props: true,
    component: () => import("../views/ReportsOverview.vue"),
  },
  {
    path: "/AlertsOverview",
    Name: "AlertsOverview",
    props: true,
    component: () => import("../views/AlertsOverview.vue"),
  },
  {
    path: "/SupportRequestClarence",
    Name: "SupportRequestClarence",
    props: true,
    component: () => import("../views/SupportRequestClarence.vue"),
  },
  {
    path: "/ReportsClarence",
    Name: "ReportsClarence",
    props: true,
    component: () => import("../views/ReportsClarence.vue"),
  },
  {
    path: "/SuperUserReports",
    Name: "SuperUserReports",
    component: () => import("../views/SuperUserReports.vue"),
  },
  {
    path: "/ReportsWaterTesting",
    Name: "ReportsWaterTesting",
    component: () => import("../views/ReportsWaterTesting.vue"),
  },
  {
    path: "/SupportWaterManagement",
    Name: "SupportWaterManagement",
    component: () => import("../views/SupportWaterManagement.vue"),
  },
  {
    path: "/WaterManagementOverview",
    Name: "WaterManagementOverview",
    beforeEnter: requireAuth,
    component: () => import("../views/WaterManagementOverview"),
  },
  {
    path: "/SuperUser",
    Name: "SuperUser",
    beforeEnter: requireAuth,
    component: () => import("../views/SuperUser"),
  },
  {
    path: "/DashboardClarenceFull",
    Name: "DashboardClarenceFull",
    component: () => import("../components/DashboardClarenceFull"),
  },
  {
    path: "/TrendData",
    Name: "TrendData",
    props: true,
    component: () => import("../components/TrendData"),
  },
  {
    path: "/Testers",
    Name: "Testers",
    props: true,
    component: () => import("../components/Testers"),
  },
  {
    path: "/RiskAssessmentQuestionnaire",
    Name: "RiskAssessmentQuestionnaire",
    props: true,
    component: () => import("../components/RiskAssessmentQuestionnaire"),
  },
  {
    path: "/LinkDevices",
    Name: "LinkDevices",
    props: true,
    component: () => import("../components/LinkDevices"),
  },

  {
    path: "/PDF",
    Name: "PDF",
    props: true,
    component: () => import("../views/PDFTemplate"),
  },
  {
    path: "/Maintenance",
    Name: "Maintenance",
    props: true,
    component: () => import("../views/Maintenance"),
  },
  {
    path: "/Service",
    Name: "Service",
    props: true,
    component: () => import("../views/ClientService"),
  },
  // {
  //   path: "/search",
  //   name: "Search",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Search.vue"),
  // },
  // {
  //   path: "/unitstatus",
  //   name: "UnitStatus",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/UnitStatus.vue"),
  // },
  // {
  //   path: "/uniterrors",
  //   name: "UnitErrors",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/UnitErrors.vue"),
  // },
  // {
  //   path: "/admin",
  //   name: "Admin",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Admin.vue"),
  // },
  // {
  //   path: "/unitstatusreport",
  //   Name: "UnitStatusReport",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/UnitStatusReport.vue"),
  // },
  // {
  //   path: "/unitalarmreport",
  //   Name: "UnitAlarmReport",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/UnitAlarmReport.vue"),
  // },
  // {
  //   path: "/uniterrorreport",
  //   Name: "UnitErrorReport",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/UnitErrorReport.vue"),
  // },
  // {
  //   path: "/handhygienereport",
  //   Name: "HandHygieneReport",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/HandHygieneReport.vue"),
  // },
  // {
  //   path: "/currentuserreport",
  //   Name: "CurrentUserReport",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/CurrentUserReport.vue"),
  // },
  // {
  //   path: "/consumablesreport",
  //   Name: "ConsumablesReport",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/ConsumablesReport.vue"),
  // },
    // {
  //   path: "/commission",
  //   Name: "Commission",
  //   component: () => import("../views/Commission.vue"),
  // },
    // {
  //   path: "/CalibrationAdmin",
  //   Name: "Calibration",
  //   props: true,
  //   component: () => import("../components/CalibrationSUP.vue"),
  // },
    // {
  //   path: "/WashbasinDashboard",
  //   Name: "WashbasinDashboard",
  //   props: true,
  //   component: () => import("../views/WashbasinDashboard.vue"),
  // },
    // {
  //   path: "/SupportRequestWashbasin",
  //   Name: "SupportRequestWashbasin",
  //   props: true,
  //   component: () => import("../views/SupportRequestWashbasin.vue"),
  // },
    // {
  //   path: "/Installer",
  //   Name: "Installer",
  //   beforeEnter: requireAuth,
  //   component: () => import("../views/Installer"),
  // },
    // {
  //   path: "/O1Layout",
  //   Name: "O1Layout",
  //   component: () => import("../views/O1Layout.vue"),
  // },
  // {
  //   path: "/WashbasinAdmin",
  //   Name: "WashbasinAdmin",
  //   component: () => import("../views/WashbasinAdmin"),
  // },
    // {
  //   path: "/SupportCombined",
  //   Name: "SupportCombined",
  //   component: () => import("../views/SupportCombined.vue"),
  // },
    // {
  //   path: "/ReportsWashbasin",
  //   Name: "ReportsWashbasin",
  //   props: true,
  //   component: () => import("../views/ReportsWashbasin.vue"),
  // },
    // {
  //   path: "/AlertsWashbasin",
  //   Name: "AlertsWashbasin",
  //   props: true,
  //   component: () => import("../views/AlertsWashbasin.vue"),
  // },
    // {
  //   path: "/OrderSundries",
  //   Name: "OrderSundries",
  //   props: true,
  //   component: () => import("../views/OrderSundries"),
  // },
    // {
  //   path: "/AlertsClarence",
  //   Name: "AlertsClarence",
  //   props: true,
  //   component: () => import("../views/AlertsClarence.vue"),
  // },
    // {
  //   path: "/AlertsWaterManagement",
  //   Name: "AlertsWaterManagement",
  //   component: () => import("../views/AlertsWaterManagement.vue"),
  // },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
